// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadItem_container__2sIjO","title":"UploadItem_title__K60uJ","status":"UploadItem_status__1AYAn"};